export function formatTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  } else {
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }
}

export function formatTimeLive(currentTime: number, duration: number) {
  const time = Math.floor(currentTime - duration);
  if (Math.abs(time) <= 2) return 'Live';
  return `${formatTime(Math.abs(currentTime))} / Live`;
}

export function getSliderBackground(currentTime: number, duration: number): string {
  const percentage = (currentTime / duration) * 100 || 0;
  const primary = getComputedStyle(document.documentElement).getPropertyValue('--vp-accent').trim();
  const bg = getComputedStyle(document.documentElement).getPropertyValue('--vp-controls-bg').trim();
  return `linear-gradient(to right, ${primary} 0%, ${primary} ${percentage}%, ${bg} ${percentage}%, ${bg} 100%)`;
}

export function getVolumeSliderBackground(isMuted: boolean, volume: number): string {
  const percentage = isMuted ? 0 : volume * 100 || 0;
  const primary = getComputedStyle(document.documentElement).getPropertyValue('--vp-accent').trim();
  const bg = getComputedStyle(document.documentElement).getPropertyValue('--vp-controls-bg').trim();
  return `linear-gradient(to right, ${primary} 0%, ${primary} ${percentage}%, ${bg} ${percentage}%, ${bg} 100%)`;
}

export function resetControlsTimeout(component: any) {
  if (component.controlsTimeout) {
    clearTimeout(component.controlsTimeout);
  }
  component.controlsTimeout = setTimeout(() => {
    if (component.isPlaying) {
      component.showControls = false;
      component.showSettings = false;
    }
  }, 3000);
}

export function formatLocalTime(utcTimeString: string): string {
  const date = new Date(utcTimeString);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}
